import pubnub from '../common/pubnub';

export const publishToClient = (shopId, userId, message) => {
  const channel = `handoff_${shopId}_${userId}`;
  return new Promise((resolve) => {
    pubnub.publish({
      channel,
      message: {
        ...message,
        masterId: pubnub.getUUID(),
      },
    }, (status) => {
      if (status.error) {
        resolve(false);
      }
      resolve(true);
    });
  });
};
